import { forwardRef } from 'react'
import { StickyBanner } from '@reward-platform/lift/components'
import { RichText } from '~/components/contentful/ContentfulRichText'
import { IconName } from '@reward-platform/lift/components/Icon/Icon.types'
import { useStickyBanner } from '~/hooks/useStickyBanner'
import { StickyBannerType } from '~/hooks/useStickyBanner/useStickyBanner'

const IconType: Record<StickyBannerType, IconName> = {
  ERROR: 'warning',
  INFO: 'info',
  SUCCESS: 'check-circle',
  WARNING: 'info',
  PROMOTION: 'gift',
}

type StickyBannersProps = {
  className?: string
  'data-testid'?: string
}

export const StickyBanners = forwardRef<HTMLDivElement, StickyBannersProps>(function StickyBanners(
  { className, 'data-testid': dataTestId },
  ref
) {
  const banners = useStickyBanner()

  return (
    <StickyBanner.StickyContainer
      ref={ref}
      className={className}
      data-testid={dataTestId}
      style={{ top: 'var(--rp-sticky-banner-top, 0px)' }}
    >
      {banners.map((banner) => (
        <StickyBanner
          variant={banner.type}
          key={banner.identifier}
          icon={IconType[banner?.type as StickyBannerType]}
          isClosable={banner.closable}
        >
          <RichText document={banner.message} />
        </StickyBanner>
      ))}
    </StickyBanner.StickyContainer>
  )
})
